import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pg-page',
  templateUrl: './pg-page.component.html',
  styleUrls: ['./pg-page.component.scss']
})
export class PgPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
